module.exports = __webpack_public_path__ + "img/BTC.0dd5c8c4.svg";